export const DATA_FETCHED = 'fetched';
export const DATA_UPDATED = 'updated';
export const ENTITY_FETCHED = 'entity_fetched';
export const CLEAR_STATE = 'clear_state';
export const DATA_STORED = 'data_stored';
export const DATA_ERROR = 'data_error';
export const ADD_DATA = 'add_data';
export const EDIT_DATA = 'edit_data';
export const SET_LIMIT = 'set_limit';
export const SET_PAGE = 'set_page';
export const SET_KEYWORD_FILTER = 'set_keyword_filter';
export const LOG_IN = 'log_in';
export const LOG_OUT = 'log_out';
export const DATA_DELETE = 'data_delete';
export const DATA_EDIT = 'data_edit';
export const UPDATE_USER = 'update_user';
export const ADD_USER = 'add_user';
export const REMOVE_USER = 'remove_user';
export const REMOVE_DATA = 'remove_data';
export const REMOVE_DATAS = 'remove_datas';
export const UPDATE_PRODUCT = 'update_product';
export const ADD_PRODUCT = 'add_product';
export const REMOVE_PRODUCT = 'add_product';
export const SWITCH_ROLE = 'switch_role';
export const REMOVE_KIOSK = 'remove_kiosk';
export const DATA_SORTED = 'data_sorted';
export const GET_MAP_STYLES = 'get_styles';
export const URLS_FETCHED = 'urls_fetched';
export const SET_PRODUCT_ID = 'set_product_id';
export const SET_SHOW_FILTERS = 'set_show_filters';
export const SET_SIDE_FILTER_LIST = 'set_side_filter_list';
export const SET_ACTIVE_FILTERS = 'set_active_filters';
export const SET_AUDIT_DIALOG_SHOW = 'set_audit_dialog_show';
export const SET_AUDIT_DIALOG_DATA = 'set_audit_dialog_data';
export const SET_ALLOW_END_TIME_OVERRIDE = 'set_allow_end_time_override';
export const FETCHED_OCCUPANCY = 'fetched_occupancy';
export const FETCH_PARKING_SPOTS = 'fetch_parking_spots';
export const SET_SORT_DURATION = 'set_sort_duration';
export const TOGGLE_SHORT_SEARCH = 'toggle_short_search';
export const SET_RECEIPT_URL = 'set_receipt_url';
export const LANGUAGES_FETCHED = 'languages_fetched';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js